export const fileIconsModule = angular
	.module('sharebase.fileIcons',[
		'ngMaterial'
	])
	.config(['$mdIconProvider', $mdIconProvider => {
		$mdIconProvider
			.icon('fileIcon:audio', './assets/format-icon-audio.svg',24)
			.icon('fileIcon:code', './assets/format-icon-code.svg',24)
			.icon('fileIcon:excel', './assets/format-icon-excel.svg',24)
			.icon('fileIcon:onenote', './assets/format-icon-onenote.svg',24)
			.icon('fileIcon:pdf', './assets/format-icon-pdf.svg',24)
			.icon('fileIcon:ppt', './assets/format-icon-ppt.svg',24)
			.icon('fileIcon:word', './assets/format-icon-word.svg',24)
			.icon('fileIcon:file', './assets/format-icon-file.svg',24)
			.icon('fileIcon:zip', './assets/format-icon-zip.svg',24)
			.icon('fileIcon:image', './assets/format-icon-image.svg',24)
			.icon('fileIcon:video', './assets/format-icon-video.svg',24)
			.icon('fileIcon:text', './assets/format-icon-text.svg',24)
			.icon('fileIcon:mail', './assets/format-icon-mail.svg',24)
			.icon('logo:icon', './assets/logo-icon.svg',24)
			.icon('list:alt', './assets/baseline-list_alt-24px.svg',24)
			.icon('logo:msOffice', './assets/ms-office-logo-icon.svg',24);
	}])
	.filter('sbFileIcon', FileIcon)
	.filter('sbFileIconBGColor', FileIconBGColor)
	.filter('sbFileIconColor', FileIconColor)
	.filter('sbHasPreviews', HasPreviews)
	.filter('sbHasThumbnails', HasThumbnails)
	.filter('sbFileName', GetFileName)
	.filter('sbFileExtention', GetFileExtention);

/**
* @ngdoc filter
* @name sharebase.fileIcons.filter:sbFileIcon
* @kind function
* 
* @description
*  Returns a icon for a filename
*
* @param {string} svgIcon in string.
* 
*/
function FileIcon() {	
	return function getFileIcon(val:string) {
		if(val.indexOf('.') === -1 ){return 'fileIcon:file';}
		let filenamePieces = val.split('.');
		let extension = filenamePieces.pop().toLowerCase();
		switch(extension){
			case 'doc':
			case 'docx':
			case 'dot':
			case 'dotx':
				return 'fileIcon:word';
			case 'xls':
			case 'xlsx':
			case 'xlsm':
			case 'xlsb':
				return 'fileIcon:excel';
			case 'pptx':
			case 'ppt':
			case 'potx':
			case 'pot':
				return 'fileIcon:ppt';
			case 'one':
				return 'fileIcon:onenote';
			case 'pdf':
				return 'fileIcon:pdf';
			case 'zip':
			case 'bz2':
			case 'gz':
			case 'rar':
			case '7z':
				return 'fileIcon:zip';
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
			case 'tif':				
			case 'tiff':
			case 'svg':
			case 'bmp':
				return 'fileIcon:image';
			case 'html':
			case 'htm':
			case 'css':
			case 'js':
			case 'ts':
			case 'mht':
				return 'fileIcon:code';
			case 'msg':
				return 'fileIcon:mail';
			case 'txt':
			case 'bat':
			case 'config':
			case 'log':		
			case 'md':
			case 'rtf':
				return 'fileIcon:text';	
			case 'wav':
			case 'mp3':
			case 'wma':
			case 'pcm':
			case 'aiff':
			case 'aac':
			case 'ogg':
			case 'flac':
			case 'alac':
				return 'fileIcon:audio';
			case 'avi':
			case 'asf':
			case 'mov':
			case 'qt':
			case 'avchd':
			case 'flv':
			case 'mpeg':
			case 'mp4':
			case 'wmv':
			case 'divx':
			case 'm4v':
			case 'mts':
			case 'mkv':
			case 'webm':
			case '3gp':
				return 'fileIcon:video';
			default:
				return 'fileIcon:file';
		}

	};

}
/**
* @ngdoc filter
* @name sharebase.fileIcons.filter:FileIconBGColor
* @kind function
* 
* @description
*  Returns a class for styling file icon backgrounds, used for lists
*
* @param {string} filename in string.
* 
*/
function FileIconBGColor() {	
	return function getFileIconBGColor(val) {
		if(val.indexOf('.') === -1 ){return 'fileIcon:file';}
		var extention = val.split('.');
		switch(extention[extention.length - 1].toLowerCase()){
			case 'doc':
			case 'docx':
			case 'dot':
			case 'dotx':
				return ' app--background-indigo';
			case 'xls':
			case 'xlsx':
			case 'xlsm':
			case 'xlsb':
				return ' app--background-green';
			case 'pptx':
			case 'ppt':
			case 'potx':
			case 'pot':
				return ' app--background-deep-orange';
			case 'one':
				return ' app--background-purple';
			case 'pdf':
				return ' app--background-red';
			case 'zip':
			case 'bz2':
			case 'gz':
			case 'rar':
			case '7z':
				return '';
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
			case 'tif':				
			case 'tiff':
			case 'svg':
			case 'bmp':
				return ' app--background-dark-blue';
			case 'html':
			case 'htm':
			case 'css':
			case 'js':
			case 'ts':
				return '';
			case 'msg':
				return ' app--background-orange';
			case 'txt':
			case 'bat':
			case 'config':
			case 'log':		
			case 'md':
				return '';
			case 'wav':
			case 'mp3':
			case 'wma':
			case 'pcm':
			case 'aiff':
			case 'aac':
			case 'ogg':
			case 'flac':
			case 'alac':
				return ' app--background-darker-blue';
			case 'avi':
			case 'asf':
			case 'mov':
			case 'qt':
			case 'avchd':
			case 'flv':
			case 'mpeg':
			case 'mp4':
			case 'wmv':
			case 'divx':
			case 'm4v':
			case 'mts':
			case 'mkv':
			case 'webm':	
				return ' app--background-darker-blue';
			default:
				return '';
		}

	};

}

/**
* @ngdoc filter
* @name sharebase.fileIcons.filter:sbFileIconColor
* @kind function
* 
* @description
*  Returns a class for styling file icon color, used for cards
*
* @param {string} filename in string.
* 
*/
function FileIconColor() {	
	return function getFileIconColor(val) {
		if(val.indexOf('.') === -1 ){return 'fileIcon:file';}
		var extention = val.split('.');
		switch(extention[extention.length - 1].toLowerCase()){
			case 'doc':
			case 'docx':
			case 'dot':
			case 'dotx':
				return ' app--color-indigo';
			case 'xls':
			case 'xlsx':
			case 'xlsm':
			case 'xlsb':
				return ' app--color-green';
			case 'pptx':
			case 'ppt':
			case 'potx':
			case 'pot':
				return ' app--color-deep-orange';
			case 'one':
				return ' app--color-purple';
			case 'pdf':
				return ' app--color-red';
			case 'zip':
			case 'bz2':
			case 'gz':
			case 'rar':
			case '7z':
				return '';
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
			case 'tif':				
			case 'tiff':
			case 'svg':
			case 'bmp':
				return ' app--color-dark-blue';
			case 'html':
			case 'htm':
			case 'css':
			case 'js':
			case 'ts':
				return '';
			case 'msg':
				return ' app--color-orange';
			case 'txt':
			case 'bat':
			case 'config':
			case 'log':		
			case 'md':
				return '';
			case 'wav':
			case 'mp3':
			case 'wma':
			case 'pcm':
			case 'aiff':
			case 'aac':
			case 'ogg':
			case 'flac':
			case 'alac':
				return ' app--color-darker-blue';
			case 'avi':
			case 'asf':
			case 'mov':
			case 'qt':
			case 'avchd':
			case 'flv':
			case 'mpeg':
			case 'mp4':
			case 'wmv':
			case 'divx':
			case 'm4v':
			case 'mts':
			case 'mkv':
			case 'webm':	
			case '3gp':
				return ' app--color-darker-blue';
			default:
				return '';
		}

	};

}
/**
* @ngdoc filter
* @name sharebase.fileIcons.filter:sbHasPreviews
* @kind function
* 
* @description
*  Returns a boolean value if file type has previews 
*
* @param {string} filename in string.
* 
*/
function HasPreviews() {	
	return function getHasPreviews(val) {
		if(val.indexOf('.') === -1 ){return false;}
		var extention = val.split('.');
		switch(extention[extention.length - 1].toLowerCase()){
			case 'doc':
			case 'css':
			case 'csv':
			case 'js':
			case 'mht':
			case 'rtf':
			case 'docx':
			case 'xls':
			case 'xlsx':
			case 'xlsm':
			case 'xlsb':
			case 'pptx':
			case 'ppt':
			case 'pdf':
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'tif':				
			case 'tiff':
			case 'svg':
			case 'bmp':
			case 'html':
			case 'htm':
			case 'msg':
			case 'txt':
			case 'webm':
			case 'ogg':
			case 'mts':
			case 'avi':
			case 'mp4':
			case 'flv':
			case '3gp':
			case 'md':
			case 'mkv':
			case 'm4v':
			case 'mpeg':
			case 'mpg':
			case 'mp3':
			case 'mov':
			case 'wmv':
			case 'wav':
				return true;
			default:
				return false;
		}

	};
}
/**
* @ngdoc filter
* @name sharebase.fileIcons.filter:HasThumbnails
* @kind function
* 
* @description
*  Returns a boolean value if file type has previews 
*
* @param {string} filename in string.
* 
*/
function HasThumbnails() {	
	return function getHasThumbnails(val) {
		if(val.indexOf('.') === -1 ){return false;}
		var extention = val.split('.');
		switch(extention[extention.length - 1].toLowerCase()){
			case 'doc':
			case 'docx':
			case 'xls':
			case 'xlsx':
			case 'xlsm':
			case 'xlsb':
			case 'csv':
			case 'rtf':
			case 'pptx':
			case 'ppt':
			case 'pdf':
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'tif':				
			case 'tiff':
			case 'svg':
			case 'bmp':
			case 'html':
			case 'htm':
			case 'mht':
			case 'msg':
			case 'txt':
			case 'webm':
			case 'ogg':
			case 'mts':
			case 'avi':
			case 'mp4':
			case 'flv':
			case '3gp':
			case 'mkv':
			case 'm4v':
			case 'mpeg':
			case 'mpg':
			case 'mov':
			case 'wmv':
				return true;
			default:
				return false;
		}

	};

}
/**
* @ngdoc filter
* @name sharebase.fileIcons.filter:sbFileName
* @kind function
* 
* @description
*  Returns just the name of a file 
*
* @param {string} filename in string.
* 
*/
function GetFileName() {	
	return function getName(val) {
		if(val.indexOf('.') === -1 ){return val;}
		var ops = val.split('.');
		ops.pop();
		return ops.join('.');
	};

}

export interface IFileExtensionFilter{
	(filename:string) : string
}
/**
* @ngdoc filter
* @name sharebase.fileIcons.filter:sbFileExtention
* @kind function
* 
* @description
*  Returns just the extention of a file 
*
* @param {string} filename in string.
* 
*/
function GetFileExtention():IFileExtensionFilter {	
	return function getExtention(filename:string) {
		if(filename.indexOf('.') === -1 ){return '';}
		var ops = filename.split('.');
		return ops[ops.length - 1].toLowerCase();
		

	};
}


// WEBPACK FOOTER //
// ./src/sharebase/filters/fileIcons.ts